import React, { useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Mail, Calendar } from 'lucide-react';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contact Us | Nexus LBE';
  }, []);

  return (
    <div className="relative">
      {/* Hero */}
      <section className="relative overflow-hidden pt-20 pb-12 lg:pt-28 lg:pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl text-center">
          <Badge variant="outline" className="mb-4">Get in Touch</Badge>
          <h1 className="font-['Geist'] tracking-tight text-4xl sm:text-5xl lg:text-6xl mb-6">
            Let's build something extraordinary
          </h1>
          <p className="text-muted-foreground text-lg md:text-xl max-w-3xl mx-auto">
            Whether you're an IP owner, property partner, or investor, we'd love to explore 
            how Nexus LBE can bring your vision to life.
          </p>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-10 lg:py-14">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <Card>
              <CardContent className="p-6 text-center space-y-3">
                <Mail className="h-10 w-10 text-primary mx-auto" />
                <h3 className="font-['Geist'] text-xl">Geoffrey Goodwin</h3>
                <a 
                  href="mailto:geoffrey@nexuslbe.com"
                  className="inline-block text-primary hover:text-[hsl(17_62%_34%)] font-medium text-sm"
                >
                  geoffrey@nexuslbe.com
                </a>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-6 text-center space-y-3">
                <Mail className="h-10 w-10 text-primary mx-auto" />
                <h3 className="font-['Geist'] text-xl">Julian Holland</h3>
                <a 
                  href="mailto:julian@nexuslbe.com"
                  className="inline-block text-primary hover:text-[hsl(17_62%_34%)] font-medium text-sm"
                >
                  julian@nexuslbe.com
                </a>
              </CardContent>
            </Card>
          </div>

          {/* Contact Form */}
          <Card>
            <CardContent className="p-8 md:p-12">
              <div className="mb-8">
                <h2 className="font-['Geist'] text-2xl md:text-3xl mb-2">
                  Send us a message
                </h2>
                <p className="text-muted-foreground">
                  Fill out the form below and we'll get back to you within 24 hours.
                </p>
              </div>
              
              <ContactForm sourcePage="contact" />
            </CardContent>
          </Card>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <h3 className="font-['Geist'] text-xl mb-4">Our Focus Areas</h3>
            <div className="flex flex-wrap justify-center gap-2">
              <Badge variant="secondary">IP Licensing</Badge>
              <Badge variant="secondary">Property Partnerships</Badge>
              <Badge variant="secondary">Investment Opportunities</Badge>
              <Badge variant="secondary">Press Inquiries</Badge>
              <Badge variant="secondary">Career Opportunities</Badge>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
